import mask from "icons/mask.png";
import hospital from "icons/hospital.png";
import pharmacy from "icons/pharmacy.png";
import curr_mask from "icons/curr_mask.png";
import curr_hospital from "icons/curr_hospital.png";
import curr_pharmacy from "icons/curr_pharmacy.png";

export default {
  mask,
  hospital,
  pharmacy,
  curr_mask,
  curr_hospital,
  curr_pharmacy,
};
